const CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME = 'cession-type-form-control-label';

export default CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME;
